import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { type Dispatch, select } from '@swf/core/store';

export const useOpenVerifyAccount = () => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  const { modal } = useDispatch<Dispatch>();

  const openVerifyAccount = useCallback(() => {
    isEmbedded
      ? window.starsweb?.app?.execute('docverify')
      : modal.replace([{ path: '/auth/docverify' }]);
  }, [isEmbedded, modal]);

  return openVerifyAccount;
};
